import { useEffect, useState } from 'react';

/**
 *  A custom hook that takes in a children prop and an array of slot names and
 *  returns an array of children that match the slot names.
 *  Setting initial state to 0 allows hook to be used in SSR. (Window is undefined in SSR)
 */
function useScreenSize() {
  const [screenSize, setScreenSize] = useState({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(document.body);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return screenSize;
}

export default useScreenSize;
